<template>
  <el-dialog v-loading="isLoading" element-loading-text="支付处理中..." :center="center" :close-on-click-modal="closeOnClickModal" :width="dialogWidth"
    :visible="dialogVisible" top="8vh" :before-close="handleClose" @open="onDialogOpen">
    <template #title>
      <span class="el-dialog__title">{{`信用卡支付`}}</span>
    </template>
    <div class="backgroud-white cs-editor-content">

      <div class="cs-stripe-top">
        <span v-if="!!tips" class="cs-stripe-tips" v-html="tips" />
      </div>
      <div class="cs-stripe-main">
        <!-- <iframe scrolling="no" frameborder="no" :src="url" /> -->
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mixinDevice } from "@/core/mixin";
import { createCreditCardPayment } from "@/service/finance.service";

const mixin_WindowEvents = {
  created() {
    window.addEventListener("message", this.receiveMsg);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.receiveMsg);
  },
  methods: {
    receiveMsg(event) {
      if (!this.createOrderResponse || Object.isEmpty(this.createOrderResponse))
        return;

      const data = event.data;
      switch (data.cmd) {
        case "stripe": {
          this.$emit("success", data.params.success);
          break;
        }
      }
    },
  },
};

export default {
  name: "stripeHandler",
  mixins: [mixinDevice, mixin_WindowEvents],
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "700px",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    tips: {
      type: String,
      default:
        "正在跳转到付款界面。<br />如付款完成后状态未更新请稍等片刻尝试刷新；<br />多次刷新后若状态依然未更新，请联系客服工作人员进行处理。",
        // "付款完成前请不要关闭该界面。<br />如付款完成后状态未更新请稍等片刻尝试刷新；<br />多次刷新后若状态依然未更新，请联系客服工作人员进行处理。",
    },
    data: {
      workflowId: 0,
      autonomousPaymentRecordId: null,
      paymentAmount: 0,
      tipAmount: 0,
      product: null,
      description: null,
    },
  },
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  data() {
    return {
      isLoading: false,
      dialogVisible: false,
      url: "",
    };
  },
  beforeCreate() {},
  created() {
    this.reloadVisible();
  },
  mounted() {},
  computed: {
    dialogWidth() {
      return !this.isMobile() ? this.width : "100%";
    },
    paymentDesc() {
      return this.GLOBAL.enumPaymentType.getAttrValue(
        this.data.paymentType,
        "desc",
        String.empty
      );
    },
    paymentKey() {
      return this.GLOBAL.enumPaymentType.getAttrValue(
        this.data.paymentType,
        "key"
      );
    },
  },
  methods: {
    async createCreditCardPaymentToServer() {
      this.isLoading = true;
      let data = {
        WorkflowId: this.data.workflowId,
        AutonomousPaymentRecordId: this.data.autonomousPaymentRecordId,
        Product: this.data.product,
        Amount: this.data.paymentAmount,
        ServiceCharge: this.data.tipAmount,
        Comments: this.data.description,
      };
      try {
        let result = await createCreditCardPayment(data);
        if (!result) return;

        if (result.success) this.url = result.data;
        else this.$message.error(result.message);

        window.location.href = this.url;
      } catch (error) {
        console.error(error);
      }

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    reloadVisible(newValue = this.visible) {
      if (this.dialogVisible !== newValue) this.dialogVisible = newValue;
    },
    resetData() {
      this.url = "";
    },
    showDialog() {
      this.dialogVisible = true;
      this.$emit("visibleChange", this.dialogVisible);
    },
    closeDialog() {
      this.resetData();

      this.dialogVisible = false;
      this.$emit("visibleChange", this.dialogVisible);
    },
    onDialogOpen() {
      this.createCreditCardPaymentToServer();
    },
    handleClose(done) {
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-editor-content {
  padding: 0 15%;
  overflow-y: auto;

  .icon {
    padding: 0 5px;
    width: 32px;
    height: 32px;

    img {
      vertical-align: middle;
      text-align: center;
      width: 32px;
      height: 32px;
    }
  }

  .cs-stripe-top {
    display: table;
    margin: auto;
    font-size: 18px;

    span {
      display: inline-block;
      vertical-align: middle;
    }

    .cs-stripe-explain {
      text-align: center;
      margin-bottom: 10px;
    }

    .cs-stripe-tips {
      color: red;
      font-size: 14px;
    }
  }

  .cs-stripe-main {
    text-align: center;
    overflow: hidden;

    iframe {
      width: 1440px;
      height: 600px;
      margin-top: 10px;
      margin-left: calc(-50% - 230px);
    }
  }
}
</style>

<style lang="scss">
iframe {
  body {
    margin-left: calc(-50% - 220px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/stripe/stripeHandler.vue